import { Navigate } from 'react-router-dom'
// import { env } from 'src/config/env'

import { paths } from 'src/config/paths'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
// import { useCurrentUserData } from 'src/shared/features/users/api/use-current-user-data'

/** Prevents the user from accessing the website if they are signed in as an agent */
export default function BlockWebGuard({ children }: { children: React.ReactNode }) {
  // Note: This may be a method to block web access to local, prod, but not dev.
  // const shouldBlock = env.MODE === 'dev' ? false : true

  const { data: user } = useMyUserData()

  const shouldBlock = user?.role === 'admin' ? false : true

  if (shouldBlock) {
    return <Navigate to={paths.alert.path} replace />
  }

  return <>{children}</>
}
